import { Cols, Col } from 'core/ui';
import * as React from 'react';

interface Props {
	Icon: string | SvgIcon;
	title: string;
	lines: string[];
}

export function InfoCard(props: Props): React.ReactNode | null {
	if (!props.title && !props.lines.some(x => x.trim()))
		return null;

	const newLineAndSmall = (text: string, key: number) =>
		text && text.trim() ? <p key={key}><small>{text}</small></p> : null;

	return <Cols className='m-b-lg m-t-md m-l-sm text-18'>
		<Col width='2ex' className='m-r-md text-muted text-26'>
			{typeof props.Icon === 'string' ? <i className={props.Icon}></i> : <props.Icon />}
		</Col>
		<Col width='*' className={props.lines.length === 0 ? 'p-t-xs' : ''}>
			{props.title}
			{props.lines.filter(x => x ? x.trim() : null).map(newLineAndSmall)}
		</Col>
	</Cols>;
}